module.exports = __webpack_public_path__ + "img/head.055cc997.jpg";